// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CarouselScroll__carousel-wrapper-e82613 {
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
}

.CarouselScroll__carousel-wrapper-e82613::-webkit-scrollbar {
  display: none;
}

.CarouselScroll__carousel-c08cb6 {
  display: flex;
}

.CarouselScroll__carousel-item-f5fff1 {
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Carousel/CarouselScroll/CarouselScroll.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,iCAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".carousel-wrapper {\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  -webkit-overflow-scrolling: touch;\n}\n\n.carousel-wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n.carousel {\n  display: flex;\n}\n\n.carousel-item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carousel-wrapper": `CarouselScroll__carousel-wrapper-e82613`,
	"carouselWrapper": `CarouselScroll__carousel-wrapper-e82613`,
	"carousel": `CarouselScroll__carousel-c08cb6`,
	"carousel-item": `CarouselScroll__carousel-item-f5fff1`,
	"carouselItem": `CarouselScroll__carousel-item-f5fff1`
};
module.exports = ___CSS_LOADER_EXPORT___;
